import { Component, Input } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { PURCHASE_ORDER_RECEPTION_TTL_ES } from '../../purchase-order-reception/purchase-order-reception.interface';
import {
  INVOICESTATUS_ID,
  IPurchaseOrder,
  ORDERSTATUS_ID,
  RECEPTIONSTATUS_ID
} from '../purchase-order.interface';
import { PurchaseOrderService } from '../purchase-order.service';

@Component({
  selector: 'pg-purchase-order-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class PurchaseOrderSelectComponent extends SelectTemplate {
  constructor(private purchaseOrderService: PurchaseOrderService) {
    super(PURCHASE_ORDER_RECEPTION_TTL_ES, purchaseOrderService);
  }
  @Input() isInvoice: boolean;
  ngOnInit() {
    this.table.settings = {
      title: PURCHASE_ORDER_RECEPTION_TTL_ES,
      columns: [
        { header: 'Doc. Orden de Compra', field: 'numberDocument' },
        { header: 'Proveedor', field: 'providerName' },
        { header: 'Fecha de Entrega', field: 'delivery_at_short' },
        { header: 'Término de Pago', field: 'paymentTermsId' },
        { header: 'Impuesto', field: 'taxId' },
        { header: 'Estado OC', field: 'orderStatusName' },
        { header: 'Estado Recepcion', field: 'receptionStatusName' },
        { header: 'Estado Factura', field: 'invoiceStatusName' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.purchaseOrderService
      .getData$()
      .subscribe((data: IPurchaseOrder[]) => {
        for (const i in data) {
          data[i]['delivery_at_short'] = data[i]['delivery_at'].substr(0, 10);
          data[i]['orderStatusName'] = ORDERSTATUS_ID[data[i]['orderStatusId']];
          data[i]['invoiceStatusName'] =
            INVOICESTATUS_ID[data[i]['invoiceStatusId']];
          data[i]['receptionStatusName'] =
            RECEPTIONSTATUS_ID[data[i]['receptionStatusId']];
        }
        if (this.isInvoice) {
          this.table.data = data.filter(
            (row) => row['orderStatusId'] === 2 && row['invoiceStatusId'] != 3
          );
        } else {
          this.table.data = data.filter(
            (row) => row['orderStatusId'] === 2 && row['receptionStatusId'] != 3
          );
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
